export const blockIconsHardwareKeyboardArrowRight = (
	<span className='material-symbols-outlined'>keyboard_arrow_right</span>
);
